import RequestAbstract from "./RequestAbstract";

import helper from "actions/helper";
import dates from "actions/helper/dates";

const { storage } = helper;
const { msInDay } = dates;

export default class RequestCache extends RequestAbstract {
    get cacheInterval() {// days
        return 1;
    }

    async getAllFiltered(filter, sort, props) {
        if (this.isCacheActive()) {
            const res = this.getCacheData();
            if (res)
                return res;
        }

        const res = await super.getAllFiltered(filter, sort, props);
        if (res?.code === "success")
            this.setCacheData(res);

        return res;
    }

    isCacheActive() {
        const datesCache = storage('cacheDates') || {};
        const expTime = datesCache[this.link];
        const date = new Date();

        return (expTime && expTime > date.getTime());
    }

    getCacheData() {
        const allData = storage('cacheData') || {};

        return allData[this.link];
    }

    setCacheData(data) {
        const allData = storage('cacheData') || {};
        allData[this.link] = data;

        storage('cacheData', allData);

        this.setCacheExp();
    }

    setCacheExp() {
        const datesCache = storage('cacheDates') || {};
        datesCache[this.link] = new Date().getTime() + (this.cacheInterval * msInDay);

        storage('cacheDates', datesCache);
    }

    clearSelfCache() {
        const datesCache = storage('cacheDates') || {};
        datesCache[this.link] = 0;

        storage('cacheDates', datesCache);
    }
}
